import { sortBy } from 'lodash'

export const getRevenueCentersList = state =>
  sortBy(Object.values(state.revenueCenters.byId), 'name')

export const getCurrentRevenueCenter = (state, uuid) => state?.revenueCenters.byId[uuid] ?? {}
